import {
  labelUtente,
  labelUsers,
  labelSelezionato,
  labelSelected,
} from "_constants";

export const FooterShareAnswers = ({
  emailListLength,
}: {
  emailListLength: number;
}) => {
  return (
    <div className="flex-container align-center gap-3">
      <span className="text-base-regular-bold">
        {`${emailListLength} ${
          emailListLength === 1
            ? labelUtente.toLowerCase()
            : labelUsers.toLowerCase()
        }`}
      </span>
      <span className="text-base-regular">
        {emailListLength === 1 ? labelSelezionato.toLowerCase() : labelSelected}
      </span>
    </div>
  );
};
